import logo from '../imgs/rushta-logo.png';

import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import { LinkContainer } from 'react-router-bootstrap';
import React from "react";

const DHeader = () => (
    <Navbar collapseOnSelect fixed="top" bg="light" expand="lg">
        <Container >
            <Navbar.Brand href="/">
                <img
                    src={logo}
                    width="36"
                    className="img-fluid rounded-top-circle"
                    alt="Avatar Bootstrap logo"
                />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="me-auto">
                    <LinkContainer to="/">
                        <Nav.Link>Home</Nav.Link>
                    </LinkContainer>
                    <LinkContainer to="/privacy">
                        <Nav.Link>Privacy</Nav.Link>
                    </LinkContainer>
                    <LinkContainer to="/contact">
                        <Nav.Link>Contact</Nav.Link>
                    </LinkContainer>
                </Nav>
            </Navbar.Collapse>
        </Container>
    </Navbar>
);
export default DHeader;